
import { BookYear } from "@/models/book-year";
import { BookYearService } from "@/services/book-year-service";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			selectedBookYear: undefined as BookYear | undefined,
			bookYears: [] as BookYear[]
		};
	},
	computed: {
		bookYearItems(): ISelectItem<BookYear>[] {
			let b = [...this.bookYears];
			return b.sort((a: BookYear, b: BookYear): number => b.Year - a.Year).map((b) => {
				return {
					text: b.Year + "",
					value: b
				};
			});
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		async confirm() {
			if (this.selectedBookYear == null) return;
			await BookYearService.selectBookYear(this.selectedBookYear);
			this.$emit("close");
		}
	},
	async mounted() {
		this.bookYears = BookYearService.bookYears;
		this.selectedBookYear = this.bookYears.find((b) => b.Year == BookYearService.selectedBookYear);
	},
	i18nEx: {
		componentPrefix: "components.bookyear"
	}
});
